import React, { ChangeEvent, useState } from "react";
import "./DeveloperForm.scss";
import { readFile } from "../../helpers/files";
import { Button } from "@mui/material";

interface IProps {
    setStuff: (scene?: string, csvEmissionData?: string, csvZeroEmissionData?: string) => void;
}

export function DeveloperForm({setStuff}: IProps) {
    const [loading, setLoading] = useState(false);
    const [myScene, setMyScene] = useState<string|undefined>();
    const [myCSVEmissionData, setMyCSVEmissionData] = useState<string|undefined>();
    const [myCSVZeroEmissionData, setMyCSVZeroEmissionData] = useState<string|undefined>();

    const handleObjChange = (e: ChangeEvent) => {
        setLoading(true);
        const input = e.target as HTMLInputElement;
        readFile(input, (contents: string) => {
            setMyScene(contents);
            setLoading(false);
        });
    }

    const handleCSVChange = (type: 'high' | 'low') => {
        return (e: ChangeEvent) => {
            setLoading(true);
            const input = e.target as HTMLInputElement;
            readFile(input, (csvContent) => {
                if (type === 'high') {
                    setMyCSVEmissionData(csvContent);
                } else {
                    setMyCSVZeroEmissionData(csvContent);
                }
                setLoading(false);
            });
        };
    };

    const handleSubmit = () => {
        setStuff(myScene, myCSVEmissionData, myCSVZeroEmissionData);
    }

    const handleCancel = () => {
        setStuff();
    }

    return (
        <div className="developer-form-wrapper">
            <div className="developer-form">
                <h1>Upload nieuwe bestanden</h1>

                {loading ? <span><em>FF bezig...</em></span> : null}

                <div className={`form-wrapper ${loading ? 'is-loading' : ''}`}>
                    <div className="uploader-wrapper">
                        <div className="upload-button">
                            <input type="file" onChange={handleObjChange} accept={"application/gltf-buffer, model/gltf-binary, model/gltf+json"} />
                            <button>Upload GLTF</button>
                        </div>
                        {myScene ? <span onClick={() => {
                        setMyScene(undefined)
                        }}>&times;</span> : null}
                        <div className="upload-button">
                            <input type="file" onChange={handleCSVChange('high')} accept="text/csv" />
                            <button>Upload High CSV</button>
                        </div>
                        {myCSVEmissionData ? <span onClick={() => {
                            setMyCSVEmissionData(undefined)
                        }}>&times;</span> : null}
                        <div className="upload-button">
                            <input type="file" onChange={handleCSVChange('low')} accept="text/csv" />
                            <button>Upload Low CSV</button>
                        </div>
                        {myCSVZeroEmissionData ? <span onClick={() => {
                            setMyCSVZeroEmissionData(undefined)
                        }}>&times;</span> : null}
                    </div>

                    <Button onClick={handleSubmit} color={'primary'} variant={'contained'}>Opslaan</Button>
                    <Button onClick={handleCancel} color={'secondary'} variant={'contained'}>Annuleren</Button>
                </div>


            </div>
        </div>
    )
}
